import React from 'react';
import PropTypes from 'prop-types';
import IconHeader from '../../../../../../../../shared/components/IconHeader/IconHeader';
import TextInput from '../../../../../../../../shared/components/TextInput/TextInput';
import FSFlatButton from '../../../../../../../../src/components/lib/FSFlatButton';
import creditCardIcon from '../../../../../../../../static/images/credit-card-icon.svg';

export default class SavedPayment extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    submitPayment: PropTypes.func.isRequired,
    cancelAction: PropTypes.func.isRequired,
    disableButtonsWhileLoading: PropTypes.bool,
    validateTermsChecked: PropTypes.func,
    dispatch: PropTypes.func,
  };

  _handleSubmit = () => {
    this.props.submitPayment({
      paymentNonce: 'ONFILE',
      checked: this.refs && this.refs.agreeTermsConditions && this.refs.agreeTermsConditions.checked,
    });
  }

  _handleCancel = () => {
    this.props.cancelAction();
  }

  handleCheckBox = () => {
    if (this.refs.agreeTermsConditions.checked) {
      const { dispatch, validateTermsChecked } = this.props;

      dispatch(validateTermsChecked(true));
    }
  }

  render() {
    const { paymentDetails } = this.props.user;
    const yourPaymentInformationCC = (paymentDetails && paymentDetails.last4) ? `card ending in ${paymentDetails.last4}` : '';
    const yourPaymentInformationMMYY = (paymentDetails && paymentDetails.expirationMonth && paymentDetails.expirationYear) ? `${paymentDetails.expirationMonth}/${paymentDetails.expirationYear}` : '';

    const titleStyle = {
      fontSize: '16pt',
    };

    return (
      <div className='SavedPayment col-xs-12'>
        <div className='row'>
          <div className='col-xs-12'>
            <IconHeader title='Your Payment Information' icon={creditCardIcon} titleStyle={titleStyle} />
          </div>
        </div>
        <div className='row equal greenbox'>
          <div className='col-xs-12 col-sm-5'>
            <div style={{ marginRight: '10px' }}>
              <p className='title'>Credit Card on File</p>
              <TextInput
                labelStyle={{ fontWeight: 400, fontSize: '12pt' }}
                divStyle={{ marginBottom: '10px' }}
                disabled
                defaultValue={yourPaymentInformationCC}
                label='Credit Card Number'
              />
              <TextInput
                labelStyle={{ fontWeight: 400, fontSize: '12pt' }}
                divStyle={{ marginBottom: '10px' }}
                disabled
                defaultValue={yourPaymentInformationMMYY}
                label='Expiration Date'
              />
            </div>
          </div>
          <div className='col-xs-12'>
            <input
              type='checkbox'
              name='agreeTermsConditions'
              ref='agreeTermsConditions'
              onChange={this.handleCheckBox}
              style={{ margin: '10px 3px 10px 0', display: 'inline-block' }}
            />
            <div
              className='account-input-title'
              style={{ display: 'inline-block', paddingLeft: '0', marginLeft: '2px' }}
            >
              I have read and agree to the
            </div>
            <a
              href='https://www.flightstats.com/company/legal/flightstats-historical-data-export-license-terms-and-conditions/'
              rel='noopener noreferrer'
              className='termsLink'
              target='_blank'
              style={{ margin: '5px 3px', textDecoration: 'underline' }}
            >
              FlightStats Data Exports Terms and Conditions
            </a>
          </div>
        </div>
        <div className='buy-buttons' >
          <div className='row data-export-button-wrapper'>
            <FSFlatButton
              label='BUY NOW'
              onClick={this._handleSubmit}
              className='button buy-button'
              disabled={this.props.disableButtonsWhileLoading}
            />
          </div>
          <div className='row data-export-button-wrapper'>
            <FSFlatButton
              label='CANCEL'
              onClick={this._handleCancel}
              className='button cancel-button'
              disabled={this.props.disableButtonsWhileLoading}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/PurchaseData/children/Payment/children/SavedPayment/SavedPayment.js